import PropTypes from 'prop-types';
import React from 'react';
import ProjectContainer from '../core/project/ProjectContainer';
import OntologyImport from './OntologyImport';

class OntologyImportContainer extends React.Component {

    render() {
        
        return (
            <ProjectContainer {...this.props}
                disableScreen={true}
                component={OntologyImport} />
        );
    }
}

OntologyImportContainer.propTypes = {
    id: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    project: PropTypes.string.isRequired,
    baseLink: PropTypes.string.isRequired
};

export default OntologyImportContainer;